import React from 'react';

import withStyles from '@mui/styles/withStyles';
import MUITab from '@mui/material/Tab';

const Tab = withStyles(() => ({
  root: {
    minWidth: 0,
  },
}))((props) => <MUITab disableRipple {...props} />);

export default Tab;
